import { useEffect } from 'react'
import { savePaidSearch, saveSearchEngine } from '@/src/helpers/cookies'
import { usePathname, useSearchParams } from 'next/navigation'

export default function useTracking() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const gclid = searchParams?.get('gclid')?.toString()

  useEffect(() => {
    if (typeof document !== 'undefined') {
      saveSearchEngine(document.referrer)
    }
  }, [pathname])

  useEffect(() => {
    if (gclid) {
      savePaidSearch()
    }
  }, [gclid])
}
